var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { atom, useAtom } from "jotai";
import { useCallback } from "react";
import { useAtomValue } from "jotai";
import { getPopupPosition } from "../utils/popup";
import { metrics } from "../analytics/events";
import { getDefaultLocale } from "../locales";
var CONNECT_ENV = process.env.UBISOFT_CONNECT_ENV;
var APP_ID = process.env.UBISOFT_APP_ID;
var GENOME_ID = process.env.UBISOFT_GENOME_ID;
export var UbisoftSDK = atom(null);
UbisoftSDK.onMount = function (setAtom) {
    window.Connect.init({
        env: CONNECT_ENV,
        appId: APP_ID,
        genomeId: GENOME_ID,
        lang: getDefaultLocale(),
        nextUrl: encodeURIComponent(getLoginRedirectCallback()),
        thirdPartyCookiesSupport: true,
    });
    window.Connect.sdk.subscribe(function (sdk) {
        setAtom(sdk);
    });
};
var UbisoftLogoutTime = atom(Date.now());
var UbisoftTicketReset = atom(Date.now());
UbisoftTicketReset.onMount = function (setAtom) {
    function listener(e) {
        if (e.data === "settlers-artbook/check-login") {
            setAtom(Date.now());
        }
    }
    window.addEventListener("message", listener);
    return function () {
        window.removeEventListener("message", listener);
    };
};
export var UbisoftTicket = atom(function (get) { return __awaiter(void 0, void 0, void 0, function () {
    var ticketDate, logoutDate, sdk;
    return __generator(this, function (_a) {
        ticketDate = get(UbisoftTicketReset);
        logoutDate = get(UbisoftLogoutTime);
        if (logoutDate > ticketDate)
            return [2 /*return*/, "no-ticket"];
        sdk = get(UbisoftSDK);
        if (sdk == null)
            return [2 /*return*/, "loading"];
        return [2 /*return*/, new Promise(function (resolve) {
                var res = sdk.getTicket();
                if (res == null) {
                    resolve("no-ticket");
                    return;
                }
                res.subscribe(function (ticketResponse) {
                    onTicketUpdate(ticketResponse);
                    if (ticketResponse.status === "ok") {
                        resolve(ticketResponse.payload);
                    }
                    else {
                        resolve("no-ticket");
                    }
                });
            })];
    });
}); });
var firstUpdate = true;
function onTicketUpdate(ticketResponse) {
    if (firstUpdate) {
        firstUpdate = false;
        if (ticketResponse.status === "ok") {
            metrics.onInitialLoad(true, ticketResponse.payload.userId);
        }
        else {
            metrics.onInitialLoad(false);
        }
    }
    else {
        if (ticketResponse.status === "ok") {
            metrics.onLogin(ticketResponse.payload.userId);
        }
        else {
            metrics.onLogout();
        }
    }
}
function useSetLogoutTime() {
    var _a = __read(useAtom(UbisoftLogoutTime), 2), set = _a[1];
    return useCallback(function () {
        set(Date.now());
    }, [set]);
}
export function useLogout() {
    var sdk = useAtomValue(UbisoftSDK);
    var ticket = useAtomValue(UbisoftTicket);
    var setLogoutTime = useSetLogoutTime();
    return useCallback(function () {
        if (sdk == null || ticket === "no-ticket" || ticket === "loading") {
            return;
        }
        setLogoutTime();
        sdk.logout(ticket.ticket, ticket.sessionId).subscribe(function () {
            setLogoutTime();
            metrics.onLogout();
        });
    }, [setLogoutTime, sdk, ticket]);
}
export var UbisoftUserProfiles = atom(function (get) {
    var sdk = get(UbisoftSDK);
    var ticket = get(UbisoftTicket);
    if (sdk == null || ticket === "no-ticket" || ticket === "loading")
        return null;
    return new Promise(function (resolve) {
        sdk
            .getProfiles(ticket.ticket, ticket.sessionId, ticket.userId)
            .subscribe(function (res) {
            if (res.status === "ok") {
                resolve(res.payload.profiles);
            }
            else {
                resolve(null);
            }
        });
    });
});
export var UbisoftUser = atom(function (get) {
    var profiles = get(UbisoftUserProfiles);
    if (profiles == null || profiles.length === 0)
        return null;
    return profiles[0];
});
export function openUbisoftLoginPopup() {
    var params = new URLSearchParams({
        appId: process.env.UBISOFT_APP_ID,
        genomeId: process.env.UBISOFT_GENOME_ID,
        lang: getDefaultLocale(),
        nextUrl: getLoginPopupCallback(),
    });
    var url = new URL("/login?" + params.toString(), process.env.UBISOFT_CONNECT_URL);
    var _a = getPopupPosition(480, 720), left = _a.left, top = _a.top;
    window.open(url, "_blank", "width=480,height=720,screenX=".concat(left, ",top=").concat(top, ",toolbar=no,status=no"));
}
function getLoginPopupCallback() {
    return process.env.LOGIN_POPUP_CALLBACK.replace(":locale", getDefaultLocale());
}
function getLoginRedirectCallback() {
    return process.env.LOGIN_REDIRECT_CALLBACK.replace(":locale", getDefaultLocale());
}
